export const BRAND_NAME = "SVC Central";
export const BRAND_PORTAL_SUFFIX = "SCO";
export const BRAND_PORTAL_TITLE = `${BRAND_NAME} - ${BRAND_PORTAL_SUFFIX}`;

// Login title options. Switch ACTIVE_LOGIN_TITLE to any value below.
export const LOGIN_TITLE_OPTIONS = {
  portal: { primary: "SVC Central", secondary: "SCO Portal" },
  welcome: { primary: "Welcome to", secondary: "SVC Central SCO" },
  serviceCenter: { primary: "SVC Central", secondary: "Service Center Portal" },
  owner: { primary: "SVC Central", secondary: "for Service Center Owners" },
};

export const ACTIVE_LOGIN_TITLE = LOGIN_TITLE_OPTIONS.portal;
export const LOGIN_SUBTITLE = "Sign in as a Service Center Owner";
export const REGISTER_TITLE = `Create your ${BRAND_PORTAL_SUFFIX} account`;
export const REGISTER_SUBTITLE = `Join ${BRAND_NAME} as a Service Center`;
export const COPYRIGHT_YEAR = 2025;
